/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-no-bind */
// eslint-disable-next-line no-use-before-define
import React, {
  ReactElement,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  ConfigProvider,
  Form,
  Grid,
  Input,
  Layout as LayoutAnt,
  Modal,
  Row,
  Select,
  Space,
  theme,
  Tooltip,
} from 'antd';

import { apiBaseUrl, config } from 'core/config';
import 'layout/styles.less';
import { ApplicationState } from 'store/combineReducers';
import { Logo } from 'shared/components/logo';
import {
  MessageOutlined,
  MoonOutlined,
  PartitionOutlined,
  SunOutlined,
} from '@ant-design/icons';
import { RolesEnum } from 'core/models';
import { useTranslation } from 'react-i18next';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import {
  getStoredUserLanguage,
  storeAccessToken,
  storeRefreshToken,
} from 'utils/localStorage';
import { apiChooseSite } from 'pages/sites/sites.service';
import { baseUrlUser } from 'utils/api';
import { apiPatientsAllList } from 'pages/patientsManagement/patientsManagement.service';
import {
  setCurrSiteId,
  setDataMap,
  setVivalinkTheme,
} from 'reducers/session/session';
import NotificationCenter from 'baseComponent/notificationCenter/notification-center';
import { commonFilterOption, isMobileApp } from 'utils/util';

import { SideBar } from './components/sideBar';
import { AvatarDropdown } from './components/avatarDropdown';
import GlobalMessage from './components/globalMessage';
import Agent from './components/agent';
import { SearchField } from './components/searchBar';
import AI_btn_url from './ai-btn.png';
import ExpireMessage from './components/expireMessage';

const {
  dataAnalytics,
  patients,
  restorePassword,
  verifyPassword,
} = config.paths;

const { useBreakpoint } = Grid;
interface LayoutProps {
  children: ReactNode[] | ReactNode;
}

const { Header, Content } = LayoutAnt;

export default function Layout({ children }: LayoutProps): ReactElement {
  const { t } = useTranslation();
  const history: History = useHistory();
  const { isAuth, user, siteList, dataMap, vivalinkTheme } = useSelector(
    (state: ApplicationState) => state.session,
  );
  const isVivaLNKAdmin = useMemo(
    () =>
      user?.roles.find(
        (item: any) =>
          item.name === RolesEnum.VivaLNKAdmin ||
          item.name === RolesEnum.SuperAdmin,
      ),
    [user],
  );
  const [isDark, setIsDark] = useState(
    localStorage.getItem('vivalinkTheme') === 'dark',
  );
  const { settingInfo } = useSelector(
    (state: ApplicationState) => state.settingInfo,
  );
  const dispatch = useDispatch();
  const [siteValue, setSiteValue] = useState(user?.siteId);
  const [siteLoading, setSiteLoading] = useState(false);
  const [form] = Form.useForm();
  const [isShowGlobalMessage, setIsShowGlobalMessage] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [routeItems, setRouteItems] = useState([
    {
      href: baseUrlUser(user?.roles[0].name),
      title: 'Home',
    },
  ]);

  useEffect(() => {
    if (vivalinkTheme) {
      setIsDark(vivalinkTheme === 'dark');
    }
  }, [vivalinkTheme]);

  useEffect(() => {
    const newRoute: any = [];
    const strArr = window.location.pathname.split('/').filter((item) => item);
    if (
      [dataAnalytics, restorePassword, verifyPassword].includes(`/${strArr[0]}`)
    ) {
      newRoute.push({ title: t(`menu.${strArr[0]}`) });
    } else {
      strArr.forEach((item, i) => {
        const newItem: any = {
          title: item.length === 36 ? t('common.detail') : t(`menu.${item}`),
        };
        if (window.location.pathname.startsWith(patients) && i === 2) {
          const target = dataMap[strArr[i]];
          if (target) {
            newItem.title =
              target.subjectId || `${target.firstName} ${target.lastName}`;
          }
        }
        if (
          (i > 0 && i <= 2 && i < strArr.length - 1) ||
          ['reports'].includes(item)
        ) {
          newItem.className = 'vivalink_breadcrumb_link';
          newItem.onClick = () =>
            history.push(`/${strArr.slice(0, i + 1).join('/')}`);
        }
        if (i < 4) {
          newRoute.push(newItem);
        }
      });
    }
    setRouteItems(newRoute);
  }, [user, history, window.location.pathname, dataMap]);

  const getPatientsAllList = async () => {
    const res = await apiPatientsAllList();
    if (res?.status === 200) {
      const newMap: Record<string, any> = {};
      res?.data?.data.forEach((item) => {
        newMap[item.id] = item;
      });
      dispatch(setDataMap({ dataMap: { ...dataMap, ...newMap } }));
    }
  };

  useEffect(() => {
    if (
      user?.roles?.length === 1 &&
      user?.roles?.[0]?.name === RolesEnum.Analyst
    ) {
      return;
    }
    if (siteValue && isAuth) {
      getPatientsAllList();
    }
  }, [siteValue, user?.id, isAuth]);

  useEffect(() => {
    const unListen = history.listen(() => {
      setChatOpen(false);
      Modal.destroyAll();
    });
    return (): void => {
      unListen();
    };
  }, [history]);

  useEffect(() => {
    if (siteValue) {
      dispatch(setCurrSiteId({ currSiteId: siteValue }));
    }
  }, [siteValue]);

  useEffect(() => {
    if (user != null) {
      setSiteValue(sessionStorage.siteId || user.siteId);
      sessionStorage.removeItem('siteId');
      if (user?.tenant?.rpmStatus) {
        let isPm = false;
        let isPhysician = false;
        let isTechnician = false;
        let isResearcher = false;
        user.roles?.forEach((item: any) => {
          if (item.name === RolesEnum.ProgramManager) {
            isPm = true;
            return;
          }
          if (item.name === RolesEnum.Physician) {
            isPhysician = true;
            return;
          }
          if (item.name === RolesEnum.Technician) {
            isTechnician = true;
            return;
          }
          if (item.name === RolesEnum.Researcher) {
            isResearcher = true;
          }
        });

        if (
          settingInfo?.rpmAlertStatus != null &&
          !settingInfo?.rpmAlertStatus
        ) {
          setIsShowGlobalMessage(false);
        } else {
          setIsShowGlobalMessage(isPhysician || isTechnician);
        }
      } else {
        setIsShowGlobalMessage(false);
      }
    }
  }, [user, settingInfo]);

  const language = useMemo(() => {
    const vivalink_language = getStoredUserLanguage() ?? 'en-US';
    if (vivalink_language === 'zh-CN') {
      return zhCN;
    }
    return enUS;
  }, [getStoredUserLanguage()]);

  const isSiderLayout = useCallback((pathname: string) => {
    return (
      pathname === config.paths.termsOfUse ||
      pathname === config.paths.privacyPolicy ||
      pathname.includes(config.paths.signUp)
    );
  }, []);

  if (history.location.pathname.startsWith(config.paths.download)) {
    if (!isAuth) {
      history.push(`${config.paths.signIn}`, {
        sourcePath: history.location.pathname + history.location.search,
      });
    }
    return (
      <ConfigProvider locale={language}>
        <LayoutAnt className="full-height-page main-wrapper">
          <Content className="content">{children}</Content>
        </LayoutAnt>
      </ConfigProvider>
    );
  }

  if (!isAuth || isSiderLayout(history.location.pathname)) {
    return (
      <ConfigProvider
        locale={language}
        theme={{
          // 核心：切换主题算法
          algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        }}
      >
        <LayoutAnt className="full-height-page main-wrapper">
          <Header
            className="yahuikeji-layout-header"
            style={{ backgroundColor: isDark ? 'rgb(20,20,20)' : '#fff' }}
          >
            <Row
              style={
                isMobileApp()
                  ? {
                      height: '60px',
                      position: 'relative',
                      transform: 'translateX(-50%)',
                      left: '50%',
                    }
                  : { height: '60px' }
              }
              justify="start"
              align="middle"
            >
              <Logo dark={!isDark} />
            </Row>
          </Header>
          <Content className="content yahuikeji-layout-content">
            {children}
          </Content>
        </LayoutAnt>
      </ConfigProvider>
    );
  }

  const handleSiteChange = async (val: string) => {
    setSiteLoading(true);
    try {
      const res = await apiChooseSite(val);
      const { accessToken, siteId, refreshToken } = res.data;
      sessionStorage.setItem('siteId', siteId);
      storeAccessToken(accessToken);
      if (refreshToken) {
        storeRefreshToken(refreshToken);
      }
      setSiteValue(val);
      dispatch(setCurrSiteId({ currSiteId: val }));
      window.location.replace(
        `${window.location.origin}${baseUrlUser(user?.roles[0].name)}`,
      );
    } catch (error) {
      console.error(error);
    } finally {
      setSiteLoading(false);
    }
  };

  const handleTheme = () => {
    const newTheme = vivalinkTheme === 'light' ? 'dark' : 'light';
    localStorage.setItem('vivalinkTheme', newTheme);
    dispatch(setVivalinkTheme({ vivalinkTheme: newTheme }));
  };

  return (
    <ConfigProvider
      locale={language}
      theme={{
        // 核心：切换主题算法
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <LayoutAnt
        className="main-wrapper yahuikeji-layout"
        style={{ overflow: 'hidden' }}
      >
        {isAuth && <SideBar />}
        <LayoutAnt>
          <div className="yahuikeji-main" id="vl-main">
            <Header
              className="yahuikeji-layout-header"
              style={{
                backgroundColor: isDark ? 'rgb(20,20,20)' : '#fff',
              }}
            >
              {!user?.authMethod && <ExpireMessage />}
              <div className="left">
                <Breadcrumb items={routeItems} />
              </div>
              <div className="right">
                <div
                  style={{ fontSize: 20, marginRight: 16, cursor: 'pointer' }}
                  onClick={() => handleTheme()}
                >
                  {isDark ? <SunOutlined /> : <MoonOutlined />}
                </div>
                {user?.roles?.findIndex(
                  (item: any) => item.name === RolesEnum.Physician,
                ) !== -1 && <SearchField />}
                {isShowGlobalMessage && <GlobalMessage />}
                <NotificationCenter />
                <div className="clinic">
                  <Select
                    style={{ minWidth: 150 }}
                    onChange={(val) => handleSiteChange(val)}
                    filterOption={commonFilterOption}
                    showSearch
                    value={siteValue}
                    loading={siteLoading}
                  >
                    {siteList.map((item: any) => (
                      <Select.Option
                        key={item.id}
                        value={item.id}
                        label={item.displayName || item.name}
                      >
                        <PartitionOutlined
                          style={{ transform: 'rotate(90deg)' }}
                        />
                        {item.displayName || item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <AvatarDropdown />
              </div>
            </Header>
            <div className="yahuikeji-layout-box">
              {chatOpen ? (
                <Agent onClose={() => setChatOpen(false)} />
              ) : (
                <Content className="content">{children}</Content>
              )}
              {!chatOpen && !isVivaLNKAdmin && user?.tenant?.aiAgentEnabled && (
                <Tooltip overlay={t('ai.title')}>
                  <div
                    onClick={() => setChatOpen(!chatOpen)}
                    className="animation"
                    style={{
                      position: 'fixed',
                      right: 32,
                      bottom: 32,
                      borderRadius: '50%',
                      width: 30,
                      height: 30,
                      zIndex: 1000,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    }}
                  >
                    <img
                      src={AI_btn_url}
                      style={{
                        filter: isDark ? 'invert()' : 'invert(0%)',
                        width: '60px',
                        position: 'relative',
                        left: '-18px',
                        top: '-14px',
                      }}
                      alt=""
                    />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        </LayoutAnt>
      </LayoutAnt>
    </ConfigProvider>
  );
}
